const AiPoweredBadge = () => (
    <span className="creator-discovery-ai-badge">
        <i className="ri-sparkling-2-line" />
        AI Powered
    </span>
);

export default AiPoweredBadge;
